import { getAnnouncement } from '@api/services/announcement.service';
import { Card } from '@hyperflake/react-ui-library';
import { useQuery } from '@tanstack/react-query';
import AnnouncementCreateForm from 'modules/announcement/components/AnnouncementCreateFrom/AnnouncementCreateFrom';
import ClientList from 'modules/announcement/components/ClientList/ClientList';
import useClientListData from 'modules/clients/hooks/useClientListData';
import { PageHeading, PageTemplate } from 'modules/shared/features/content';
import { useEffect, useState } from 'react';

const AnnouncementCreatePage = () => {
    const [selectedIds, setSelectedIds] = useState<string[]>([]);
    const [selectAllChecked, setSelectAllChecked] = useState(false);
    const [searchValue, setSearchValue] = useState('');

    const { clients, isLoading } = useClientListData();

    const {
        data: announcement,
        refetch: refetchAnnouncement,
        isLoading: isAnnouncementLoading,
    } = useQuery({
        queryKey: ['announcement-banner'],
        queryFn: getAnnouncement,
    });

    useEffect(() => {
        if (announcement?.clients?.length) {
            setSelectedIds(announcement.clients);
        }
    }, [announcement]);

    const resetState = () => {
        setSelectedIds(announcement?.clients || []);
        setSelectAllChecked(false);
        setSearchValue('');
        refetchAnnouncement();
    };

    return (
        <PageTemplate>
            <div className="min-h-screen">
                <div className="flex justify-between">
                    <PageHeading>Announcement Banner</PageHeading>
                </div>

                <Card className="mt-4">
                    <Card.Body>
                        <div className="grid grid-cols-12 gap-8">
                            <div className="col-span-5 border-r pr-8">
                                <AnnouncementCreateForm
                                    announcement={announcement}
                                    clients={clients}
                                    selectedIds={selectedIds}
                                    resetState={resetState}
                                    isLoading={isAnnouncementLoading}
                                />
                            </div>

                            <div className="col-span-7">
                                <ClientList
                                    clients={clients}
                                    isLoading={isLoading}
                                    selectedIds={selectedIds}
                                    setSelectedIds={setSelectedIds}
                                    selectAllChecked={selectAllChecked}
                                    setSelectAllChecked={setSelectAllChecked}
                                    searchValue={searchValue}
                                    setSearchValue={setSearchValue}
                                />
                            </div>
                        </div>
                    </Card.Body>
                </Card>
            </div>
        </PageTemplate>
    );
};

export default AnnouncementCreatePage;
